import { PAYMENT_TYPE_OPTIONS_MAP } from "@shared/constants";
import { PaymentServiceBasket } from "../../services/useBasketPaymentService";

/**
 * Determines whether a basket should use the Affirm PaymentHandler
 */
export function shouldUseAffirmHandler(basket: PaymentServiceBasket) {
  return basket.paymentType === PAYMENT_TYPE_OPTIONS_MAP.AFFIRM.id;
}

/**
 * Determines whether a basket should use the Free PaymentHandler
 */
export function shouldUseFreeHandler(basket: PaymentServiceBasket) {
  return Number(basket.totalPrice) === 0;
}

/**
 * Determines whether a basket should use the Waitlist PaymentHandler
 */
export function shouldUseWaitlistHandler(basket: PaymentServiceBasket) {
  return basket.isWaitlist;
}
